var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExpertCodingIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Expert Coding Icon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 16 L28 32 L20 48",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44 16 L36 32 L44 48",
    fill: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 10,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32 22 V12 M32 22 L38 28 M32 22 L26 28",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32 42 V52 M32 42 L38 36 M32 42 L26 36",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42 32 H52 M42 32 L48 36 M42 32 L48 28",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 32 H2 M12 32 L8 36 M12 32 L8 28",
    fill: "none"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpertCodingIcon);
export default __webpack_public_path__ + "static/media/expert-coding-icon.814aad116aa2391e3535944f639c0f05.svg";
export { ForwardRef as ReactComponent };